import React from "react";
import { Autocomplete, TextField, Grid } from "@mui/material";
import { ISystemData } from "../../types/resource";

interface SystemTypeAutocompleteProps {
  allSystemData: ISystemData[];
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  validateField: (name: string, value: any) => void;
  errors: any;
  gridProps?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  onSystemChange?: (systemId: any) => void;
}

const SystemTypeAutocomplete: React.FC<SystemTypeAutocompleteProps> = ({
  allSystemData,
  formData,
  setFormData,
  validateField,
  errors,
  gridProps = { xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
  onSystemChange,
}) => {
  const handleSystemChange = (_: any, value: any) => {
    const systemId = value?.id || null;

    setFormData((prev: any) => ({
      ...prev,
      system_id: systemId,
      linked_service: {},
    }));

    validateField("system_id", systemId);

    // Call optional callback for additional handling
    if (onSystemChange) {
      onSystemChange(systemId);
    }
  };

  return (
    <Grid item {...gridProps}>
      <Autocomplete
        fullWidth
        options={allSystemData || []}
        getOptionLabel={(option: any) => option?.value || ""}
        value={
          allSystemData?.find(
            (system: any) => system.id === formData?.system_id
          ) || null
        }
        onChange={handleSystemChange}
        renderInput={(params) => (
          <TextField
            {...params}
            title="Enter System"
            label={
              <span className="position-relative inline-block">
                System <span className="required-asterisk">*</span>
              </span>
            }
            variant="outlined"
            className={`form-control-autocomplete ${
              errors?.system_id ? "has-error" : ""
            }`}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors?.system_id}
            helperText={errors?.system_id || ""}
          />
        )}
        renderOption={(props, option) => <li {...props}>{option?.value}</li>}
        loadingText="Loading..."
        className={`form-control-autocomplete`}
      />
    </Grid>
  );
};

export default SystemTypeAutocomplete;
